import React, { useEffect, useState, useRef } from "react";
import LifeCycle from "./charts/LifeCycle";
import Annualize from "./charts/annualize";
import Total from "./charts/total";
import { Card, CardHeader, CardBody } from "../../../components/card/card";
import { useParams } from "react-router-dom";
import { matar } from "../../../api";

function MachineList() {
  let { assetId, groupId } = useParams();
  const [listSimulation, setListSimulation] = useState([]);
  const [group, setGroup] = useState(null);
  useEffect(() => {
    if (assetId) {
      setSelectedAsset(assetId);
    }
    if (groupId) {
      getOne();
    }
  }, [assetId, groupId]);
  const getOne = async () => {
    const res = await matar.getOneGroup({ id: groupId });
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setGroup(data.MachineGroup);
      if (data.MachineGroup?.length) {
        setSelectedAsset(data.MachineGroup[0]?.machine_id);
      }
    }
  };
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [allData, setAllData] = useState([]);
  const getStrategy = async () => {
    const result2 = await matar.getStrategy({
      machine_id: selectedAsset,
    });
    if (result2.ok) {
      const body = await result2.json();
      const data = body.data;
      setListSimulation(data);
    }
  };
  const getData = async () => {
    const result = await matar.calculateMatar({
      asset_id: selectedAsset,
    });
    if (result.ok) {
      const body = await result.json();
      const data = body.data.simulation;
      console.log(data);
      setAllData(data);
    }
  };
  const changeStrategy = (e) => {
    const fetchByData = async (inc, dec, rep, ref) => {
      const result = await matar.calculateMatar({
        asset_id: selectedAsset,
        increase_pm: inc,
        decrease_pm: dec,
        replacement: rep,
        refurbishment: ref,
      });
      if (result.ok) {
        const body = await result.json();
        const data = body.data.simulation;
        setAllData(data);
      }
    };

    const selectedId = e.target.value;
    setSelectedSimulation(selectedId);
    const selectedSimulation = listSimulation.find(
      (item) => item.id === selectedId
    );
    if (selectedSimulation) {
      const prameters = selectedSimulation.parameters;
      let inc = [];
      let dec = [];
      let rep = [];
      let ref = [];
      if (prameters.increase_pm?.length > 0) {
        inc = prameters.increase_pm;
      }
      if (prameters.decrease_pm?.length > 0) {
        dec = prameters.decrease_pm;
      }
      if (prameters.replacement?.length > 0) {
        rep = prameters.replacement;
      }
      if (prameters.refurbishment?.length > 0) {
        ref = prameters.refurbishment;
      }
      fetchByData(inc, dec, rep, ref);
    } else {
      getData();
    }
  };
  useEffect(() => {
    if (selectedAsset) {
      getStrategy();
      getData();
    }
  }, [selectedAsset]);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  return (
    <div>
      <h2 className="page-header">Lifecycle</h2>
      <Card className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}>
        <CardHeader>
          <div class="row">
            {assetId ? (
              <div class="col-sm-3 pt-3">
                <div className=" fw-bold small text-white text-center">
                  Asset ID : <b>{selectedAsset}</b>
                </div>
              </div>
            ) : (
              <div className="col-sm-3">
                <div className=" fw-bold small text-white text-center">
                  <div className={"from-group my-2 w-100"}>
                    <label>Select Asset : </label>
                    {group ? (
                      <select
                        value={selectedAsset}
                        onChange={(e) => setSelectedAsset(e.target.value)}
                        className={"form-control border-theme text-theme"}
                      >
                        {group.map((item, index) => (
                          <option
                            key={index}
                            value={item.machine_id}
                            className={"text-theme"}
                          >
                            {item.machine_id}
                          </option>
                        ))}
                      </select>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
            <div class="col-sm-3">
              <div
                className={
                  "from-group my-2 w-100 fw-bold small text-white text-center"
                }
              >
                <label>Select Strategy : </label>

                <select
                  value={selectedSimulation}
                  onChange={changeStrategy}
                  className="border-theme form-control text-theme text-center form-control-sm"
                >
                  <option value="">- AI Prediction -</option>
                  {listSimulation.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item?.financialStrategies?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          {/*<LifeCycle />*/}
          <hr />
          <Annualize allData={allData} />
          <hr />
          <h3>Accumulated LCC</h3>
          <Total allData={allData} />
        </CardBody>
      </Card>
    </div>
  );
}

export default MachineList;
